import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VexRoutes } from '../@vex/interfaces/vex-route.interface';
import { AuthGuardWithForcedLogin, AuthLoadGuard, LayoutComponent } from 'dvt-lib';

const childrenRoutes: VexRoutes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'dashboard',
    //canActivate: [AuthGuard],
    loadChildren: () => import('./pages/esfuerzos/esfuerzos.module').then(m => m.EsfuerzosModule)

  },
  {
    path: 'empresas',
    //canActivate: [AuthGuard],
    loadChildren: () => import('./pages/empresas/empresa.module').then(m => m.EmpresaModule)

  },
  {
    path: 'proyectos',
    //canActivate: [AuthGuard],
    loadChildren: () => import('./pages/proyectos/proyectos.module').then(m => m.ProyectosModule)

  },
  {
    path: 'reporte',
    //canActivate: [AuthGuard],
    loadChildren: () => import('./pages/reportes/reportes.module').then(m => m.ReportesModule)
  },
  {
    path: '**',
    loadChildren: () => import('./pages/pages/errors/error-404/error-404.module').then(m => m.Error404Module)
  }
];

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./pages/authentication/authentication.module').then(m => m.AuthenticationModule),
  },
  {
    path: '',
    component: LayoutComponent,
    children: childrenRoutes,
    canActivate: [AuthGuardWithForcedLogin],
    canLoad: [AuthLoadGuard],
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    // preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'enabled',
    relativeLinkResolution: 'corrected',
    anchorScrolling: 'enabled'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
